<template>
  <div class="posterThemeItem">
    <!-- 指标项 + 单个照片|双人照片 + 横版|竖版|方板 + 文字输入框 -->
    <HTML_BAR_INDICATOR_ITEM
      v-if="
        sourceData &&
        sourceData.fileList &&
        [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(sourceData.posterId)
      "
      :currThemeObj="currThemeObj"
      :sourceData="sourceData"
      :themeItemData="themeItemData"
      :cssDynamicObj="cssDynamicObj"
      :sizeClassName="sourceData.sizeClassName"
      :isEditFlag="isEditFlag"
      @curPicItemEvent="curPicItemEventHandler"
    ></HTML_BAR_INDICATOR_ITEM>

    <!-- 表格+单个照片 -->
    <HTML_TABLE_SINGLEIMAGE
      v-if="
        sourceData && sourceData.fileList && [10].includes(sourceData.posterId)
      "
      :currThemeObj="currThemeObj"
      :sourceData="sourceData"
      :themeItemData="themeItemData"
      :cssDynamicObj="cssDynamicObj"
      :sizeClassName="sourceData.sizeClassName"
      :isEditFlag="isEditFlag"
      @curPicItemEvent="curPicItemEventHandler"
    ></HTML_TABLE_SINGLEIMAGE>
  </div>
</template>
<script>
import HTML_BAR_INDICATOR_ITEM from '@components/dataPoster/html/HTML_BAR_INDICATOR_ITEM/index.vue'
import HTML_TABLE_SINGLEIMAGE from '@components/dataPoster/html/HTML_TABLE_SINGLEIMAGE/index.vue'

export default {
  name: 'poster_themeItem',
  components: {
    HTML_BAR_INDICATOR_ITEM,
    HTML_TABLE_SINGLEIMAGE,
  },
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    sourceData: {
      type: Object,
      default: () => ({
        posterBgImageUrlBase64: '',
        posterLImageUrlBase64: '',
        type: '',
        list: [],
      }),
    },
    themeItemData: {
      type: Object,
      default: () => ({
        renderData: {},
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    currPicSize: {
      type: Array,
      default: () => {
        return []
      },
    },
    sizeClassName: {
      type: Array,
      default: () => {
        return []
      },
    },
    isEditFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    curPicItemEventHandler(childData) {
      // 子组件必须函数
      console.debug('draggableToPicItemChangeEvent themeItem:', childData)
      this.$emit('curPicItemEvent', childData)
    },
  },
}
</script>
<style lang="scss" scoped>
.posterThemeItem {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
